module.exports = __webpack_public_path__ + "img/22.d97de6fe.jpg";